import type { MediaOption } from '@/modules/message/components/editor/fields/message-media-dropdown.tsx'
import type { Message } from '@/modules/online-mass-messages/types.ts'

export function getMessageMediaNames(
  message: Message,
  mediaOptions: MediaOption[],
) {
  if (!message.medias?.length) {
    return ''
  }

  const medias = message.medias.map(({ mediaId }) => {
    return mediaOptions.find((media) => media.mediaId === mediaId)
  })

  return medias
    .map((media) => media?.name)
    .filter((name) => name)
    .join(', ')
}

export function getMessageText(
  message: Message | undefined,
  mediaOptions: MediaOption[],
) {
  if (!message) {
    return ''
  }

  if (message.text?.length > 0) {
    return message.text
  }

  return getMessageMediaNames(message, mediaOptions)
}
